import React from "react";
import {Radio as MuiRadio, RadioGroup as MuiRadioGroup, RadioProps} from "@mui/material";
import {Colors} from "../colors";

export type RadioType = RadioProps & {};
export const RadioGroup = MuiRadioGroup;

const mapCircleSizeStyles = {
  small: 20,
  medium: 24,
};

export const Radio = ({size = "small", color = "primary", sx, ...props}: RadioType) => {
  return (
    <MuiRadio
      color={color}
      sx={{
        color: Colors.grey._1000,
        svg: {
          fontSize: mapCircleSizeStyles[size],
        },
        ...sx,
      }}
      {...props}
    />
  );
};
